import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CoinsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsx("path", {
                            d: "M16.17 8.85l-1.91-.42a.451.451 0 01-.2-.78c.08-.07.19-.11.29-.12h1.26c.13 0 .25.04.36.11.11.07.18.18.23.3.18.52.75.8 1.28.61.52-.18.79-.75.61-1.28-.18-.52-.51-.95-.96-1.27-.32-.23-.68-.37-1.06-.44v-.67c0-.55-.45-1-1-1s-1 .45-1 1v.65c-.5.06-.97.26-1.35.6-.45.4-.73.96-.79 1.56-.06.6.09 1.2.44 1.69s.87.83 1.46.97l1.91.42c.15.03.28.12.37.25.09.12.13.28.11.43-.02.15-.09.29-.2.4a.62.62 0 01-.41.16h-1.06c-.13 0-.25-.04-.36-.11a.625.625 0 01-.23-.3c-.18-.52-.75-.79-1.28-.61-.52.18-.79.76-.61 1.28.18.51.51.95.96 1.27.32.22.68.37 1.05.44v.67c0 .55.45 1 1 1s1-.45 1-1v-.67a2.61 2.61 0 002.14-2.3c.07-.64-.1-1.29-.48-1.81a2.64 2.64 0 00-1.57-1.03z"
                        }),
                        _jsx("path", {
                            d: "M21.28 3.57A8.73 8.73 0 0015.07 1c-2.34 0-4.55.91-6.21 2.57a8.73 8.73 0 00-2.57 6.21c0 1.16.23 2.29.67 3.36a8.683 8.683 0 001.9 2.85c.82.82 1.78 1.46 2.85 1.9 1.07.44 2.2.67 3.36.67 1.16 0 2.29-.22 3.36-.67a8.842 8.842 0 002.85-1.9c.82-.82 1.46-1.78 1.9-2.85.44-1.07.67-2.2.67-3.36 0-2.35-.91-4.55-2.57-6.21zm.06 8.81a6.796 6.796 0 01-3.67 3.67c-1.65.69-3.54.69-5.19 0a6.797 6.797 0 01-4.19-6.27c0-1.81.71-3.52 1.99-4.8a6.756 6.756 0 014.8-1.99c1.81 0 3.52.71 4.8 1.99a6.756 6.756 0 011.99 4.8c0 .9-.17 1.77-.52 2.6h-.01z"
                        }),
                        _jsx("path", {
                            d: "M13.26 20.46c-1.3.63-2.74.83-4.17.58a6.737 6.737 0 01-3.71-1.99c-1-1.05-1.63-2.36-1.82-3.79-.19-1.43.07-2.86.76-4.14.26-.49.08-1.09-.4-1.36-.49-.26-1.09-.08-1.36.4a8.755 8.755 0 00-.98 5.36 8.724 8.724 0 002.36 4.91 8.789 8.789 0 006.36 2.72c1.32 0 2.62-.3 3.83-.89a1 1 0 00.46-1.34 1 1 0 00-1.34-.46h.01z"
                        })
                    ]
                })
            })
        ]
    });
};
CoinsIcon.isCarinaIcon = true;
export default CoinsIcon;
